var _defs, _path, _path2, _path3, _path4, _rect, _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterResistant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 174.11 174.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#696a6c;}.cls-2{fill:#5a595b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.15,177.08A87.06,87.06,0,1,1,166.27,48h0A87,87,0,0,1,90.15,177.08ZM89.89,9.92a80.1,80.1,0,1,0,70.25,41.49h0a79.53,79.53,0,0,0-47.86-38.29A80.35,80.35,0,0,0,89.89,9.92Z",
    transform: "translate(-2.94 -2.92)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.88,37.58a2.22,2.22,0,0,0-2,1.31L37.94,56.21,35,62.57A14.27,14.27,0,0,0,47.43,82.81h.9A14.27,14.27,0,0,0,60.72,62.57l-2.9-6.36L49.91,38.89a2.2,2.2,0,0,0-2-1.31m0,8.91,5.39,11.8,2.9,6.36a9.36,9.36,0,0,1-.58,8.86,8.92,8.92,0,0,1-7.41,4.3h-.6a8.93,8.93,0,0,1-7.41-4.3,9.36,9.36,0,0,1-.58-8.86l2.91-6.36Z",
    transform: "translate(-2.94 -2.92)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.89,37.58a2.2,2.2,0,0,0-2,1.31L80,56.21,77,62.57a14.27,14.27,0,0,0,12.4,20.24h.89a14.27,14.27,0,0,0,12.4-20.24l-2.91-6.36-7.9-17.32a2.22,2.22,0,0,0-2-1.31m0,8.91,5.38,11.8,2.9,6.36a9.33,9.33,0,0,1-.58,8.86,8.91,8.91,0,0,1-7.4,4.3h-.61a8.91,8.91,0,0,1-7.4-4.3,9.36,9.36,0,0,1-.58-8.86l2.9-6.36Z",
    transform: "translate(-2.94 -2.92)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.89,37.58a2.21,2.21,0,0,0-2,1.31L122,56.21l-2.9,6.36a14.27,14.27,0,0,0,12.39,20.24h.9a14.27,14.27,0,0,0,12.39-20.24l-2.9-6.36-7.91-17.32a2.21,2.21,0,0,0-2-1.31m0,8.91,5.38,11.8,2.91,6.36a9.36,9.36,0,0,1-.58,8.86,8.92,8.92,0,0,1-7.41,4.3h-.6a8.92,8.92,0,0,1-7.41-4.3,9.36,9.36,0,0,1-.58-8.86l2.91-6.36Z",
    transform: "translate(-2.94 -2.92)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26.37,
    y: 128.29,
    width: 121.14,
    height: 5.01
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.73 101.15 110.72 101.15 110.72 89.89 98.46 89.89 98.46 84.88 115.73 84.88 115.73 101.15"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "70.48 133.74 26.87 90.13 30.41 86.59 70.48 126.65 110.91 86.23 114.45 89.77 70.48 133.74"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "147.74 101.15 142.74 101.15 142.74 89.89 130.47 89.89 130.47 84.88 147.74 84.88 147.74 101.15"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "102.49 133.74 58.89 90.13 62.43 86.59 102.49 126.65 142.92 86.23 146.46 89.77 102.49 133.74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterResistant);
export default __webpack_public_path__ + "static/media/water-resistant.1d864ac0cf674be626a7e8c411cdaf74.svg";
export { ForwardRef as ReactComponent };